import Masthead from "./components/Masthead";
import Cover from "./components/Cover";
import HotRank from "./components/HotRank";
import Topics from "./components/Topics";
import MixedFeed from "./components/MixedFeed";
import TimelineBlock from "./components/TimelineBlock";
import Voices from "./components/Voices";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Masthead />
      <main>
        <Cover />
        <HotRank />
        <Topics />
        <MixedFeed />
        <TimelineBlock />
        <Voices />
      </main>
      <Footer />
    </div>
  );
}